import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import type { PropsWithChildren } from "react";

type Side = "right" | "left";

// this component is intended to indicate that further scrolling is available for the scrollbar
type EdgeShadowProps = PropsWithChildren<{
  enabled: boolean | { (): boolean };
  side?: Side;
}>;

export const EdgeShadow = observer(function EdgeShadowObserved(
  props: EdgeShadowProps,
) {
  const { enabled, side = "right", children } = props;
  return (
    <Shadow
      enabled={typeof enabled === "function" ? enabled() : enabled}
      side={side}
    >
      {children}
    </Shadow>
  );
});

const Shadow = styled.div<{
  side: Side;
  enabled: boolean;
}>`
  position: relative;

  :before {
    content: "";
    display: block;
    top: 0;
    bottom: 0;
    position: absolute;
    transition: opacity 0.3s;
    width: 5px;
    z-index: 2;
    right: ${({ side }) => (side === "right" ? "-5px" : "auto")};
    left: ${({ side }) => (side === "left" ? "-5px" : "auto")};
    opacity: ${({ enabled }) => (enabled ? 0.15 : 0)};
    background: linear-gradient(
      ${({ side }) => (side === "right" ? 90 : -90)}deg,
      #000,
      transparent
    );
  }
`;
